import { Action } from 'history';
import React, { useState } from 'react';
import { useNavigationType } from 'react-router-dom';

const ANIMATION_DURATION = 200;

export const useAnimation = (
  moveInRightClass: string,
  moveInLeftClass: string,
  dependencyArray: unknown[],
) => {
  const navigationType = useNavigationType();
  const [activeAnimation, setActiveAnimation] = useState('');

  React.useEffect(() => {
    switch (navigationType) {
      case Action.Pop:
        setActiveAnimation(moveInRightClass);
        break;
      case Action.Push:
        setActiveAnimation(moveInLeftClass);
        break;
    }
    const timeoutId = setTimeout(
      () => setActiveAnimation(''),
      ANIMATION_DURATION,
    );
    return () => clearTimeout(timeoutId);
  }, dependencyArray);

  return activeAnimation;
};
